import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, mergeProps as _mergeProps, withCtx as _withCtx } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  return _openBlock(), _createBlock(_component_el_select, _mergeProps(_ctx.$attrs, {
    "filter-method": $options.filterMethod,
    onVisibleChange: $options.visibleChange
  }), {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.optionsList, field => {
      return _openBlock(), _createBlock(_component_el_option, {
        key: field.value,
        label: field.label,
        value: field,
        disabled: $options.isDisabled(field.value)
      }, null, 8, ["label", "value", "disabled"]);
    }), 128))]),
    _: 1
  }, 16, ["filter-method", "onVisibleChange"]);
}